import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Constant} from '../../global/util/Constant';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PersonService} from '../../user/service/person.service';
import {AuthService} from '../../user/service/auth/auth.service';
import {LocalStorage} from '../../global/util/LocalStorage';
import {InformType} from '../../global/util/enum/InformType';
import {Dialog} from '../../global/util/Dialog';
import {SignService} from '../../user/service/sign.service';
import {TranslateService} from '@ngx-translate/core';
import {SignaturedescriptionList} from '../../user/model/SignaturedescriptionList';

@Component({
  selector: 'app-assign-signature-description',
  templateUrl: './assign-signature-description.component.html',
  styleUrls: ['./assign-signature-description.component.css']
})
export class AssignSignatureDescriptionComponent implements OnInit {
  public authorityForm: FormGroup;
  public loading: boolean;
  public signatureDescriptions: any[];
  public personId: number;

  constructor(public activeModal: NgbActiveModal,
              private personService: PersonService,
              private authenticationService: AuthService,
              private signService: SignService,
              private translate: TranslateService,
              private formBuilder: FormBuilder) {
    this.createForm();
  }

  ngOnInit() {
  }

  public save() {
    LocalStorage.setItem('signatureDescriptions', this.signatureDescriptions);
    LocalStorage.setItem('selectedSignatureDescriptions', this.signatureDescriptions);
    this.update();
    this.activeModal.close(InformType.Success);
  }

  public cancel() {
    this.activeModal.close(-1);
  }

  public update() {
    const signaturedescriptionList = new SignaturedescriptionList();
    signaturedescriptionList.signaturedescriptions = this.signatureDescriptions;
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/signaturedescription');
    this.signService.save(url, signaturedescriptionList).subscribe(() => {
      this.loading = false;
    }, () => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.DOCUMENT-VIEWER'));
      this.loading = false;
    });
  }

  public wasSelected(signatureDescription: any): boolean {
    return this.signatureDescriptions.find(value => value.initialized === true && value.id === signatureDescription.id) !== undefined;
  }

  public wasAllSelected1(): boolean {
    return this.signatureDescriptions.filter(signatureDescription => signatureDescription.initialized === true).length === this.signatureDescriptions.length;
  }

  public addRemove(event: any, signatureDescription: any) {
    if (event.target.checked) {
      this.signatureDescriptions.forEach(value => {
        if (value.id === signatureDescription.id) {
          value.initialized = true;
          return;
        }
      });
    } else {
      this.signatureDescriptions.forEach(value => {
        if (value.id === signatureDescription.id) {
          value.initialized = false;
          return;
        }
      });
    }
  }

  public addOrRemoveAll1(event) {
    if (event.target.checked) {
      this.signatureDescriptions.forEach(signatureDescription => {
        signatureDescription.initialized = true;
      });
    } else {
      this.signatureDescriptions.forEach(signatureDescription => {
        signatureDescription.initialized = false;
      });
    }
  }

  private createForm() {
    this.authorityForm = this.formBuilder.group({
      workflowCheckbox: ['', [Validators.required]]
    });
  }

  get areThereSelectedWorkflows() {
    return this.signatureDescriptions.length !== Constant.EMPTY_LIST;
  }
}
